module.exports = __webpack_public_path__ + "img/activity.3574cbe9.png";